var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Container from "./Container.js";
import Toolable from "./mixin/Toolable.js";
import FunctionHelper from "../helper/FunctionHelper.js";
import ArrayHelper from "../helper/ArrayHelper.js";
import DomHelper from "../helper/DomHelper.js";
import { canonicalDock } from "./mixin/Rotatable.js";
import "./layout/VBox.js";
import "./Button.js";
const asElementRefs = { refs: "element" }, onCreateTwin = (overflowTwin) => overflowTwin.element.style.margin = "", isToolbar = (w) => w.isToolbar, itemScoreFn = (ent) => ent[0] + (ent[1].minifiable ? 0 : 9e9), twinOverrides = {
  // If the initialConfig was hidden, we must override that
  hidden: false,
  // Item must obey menu's align-items : stretch style.
  width: ""
}, twinOverridesHorz = {
  ...twinOverrides,
  // Don't allow horizontal flex styles to apply in the vertical layout of the Menu.
  flex: ""
}, widthAffecting = {
  flex: 1,
  hidden: 1,
  maxWidth: 1,
  minWidth: 1,
  width: 1,
  disabled: 1
  // Need to pass Toolbar.t.js t.it("Should correctly convert button w/menu when overflowed")
}, _axisProps = [{
  box: "hbox",
  clientSizeProp: "clientWidth",
  edgeProp: "right",
  flexDir: "row",
  horizontal: true,
  max: "maxX",
  overflow: "overflowX",
  pos: "x",
  scrollSize: "scrollWidth",
  sizeProp: "width"
}, {
  box: "vbox",
  clientSizeProp: "clientHeight",
  edgeProp: "bottom",
  flexDir: "column",
  horizontal: false,
  max: "maxY",
  overflow: "overflowY",
  pos: "y",
  scrollSize: "scrollHeight",
  sizeProp: "height"
}], defaultRepeat = {
  delay: 0,
  startRate: 40,
  endRate: 200,
  accelerateDuration: 500
}, nonSyncedConfigs = {
  menu: 1,
  pressed: 1
};
const _Toolbar = class _Toolbar extends Container.mixin(Toolable) {
  /**
   * Returns the Core.widget.Widget[] of items to hide to clear an overflow. The `visibleItems` array should be in
   * order of the `items` in the container.
   * @param {Core.widget.Widget[]} visibleItems
   * @returns {Array}
   * @private
   */
  static getEvictionList(visibleItems) {
    const ret = visibleItems.filter((it) => it.overflowable !== "none");
    ret.forEach((it, n) => ret[n] = [n, it]);
    ret.sort((a, b) => itemScoreFn(b) - itemScoreFn(a));
    return ret;
  }
  compose() {
    const me = this, { axisProps, dock } = me, endToolElementRefs = me.getEndTools(asElementRefs), startToolElementRefs = me.getStartTools(asElementRefs);
    return {
      class: {
        [`b-dock-${dock}`]: 1,
        [`b-${dock}-toolbar`]: 1,
        [`b-${axisProps.box}`]: 1
      },
      children: {
        ...startToolElementRefs,
        toolbarContent: {
          class: {
            "b-box-center": 1,
            "b-toolbar-content": 1
          }
        },
        ...endToolElementRefs
      }
    };
  }
  get axisProps() {
    return _axisProps[this.layout.horizontal ? 0 : 1];
  }
  get contentElement() {
    return this.toolbarContent;
  }
  get overflowMenuButton() {
    var _a;
    return (_a = this.tools) == null ? void 0 : _a.overflowMenuButton;
  }
  get overflowType() {
    const { overflow } = this;
    return typeof overflow === "string" ? overflow : overflow == null ? void 0 : overflow.type;
  }
  onChildAdd(item) {
    var _a;
    super.onChildAdd(item);
    this.processAddedLeafItem(item);
    (_a = item.syncRotationToDock) == null ? void 0 : _a.call(item, this.dock);
  }
  onChildRemove(item) {
    super.onChildRemove(item);
    this.syncOverflowVisibility();
  }
  processAddedLeafItem(item) {
    FunctionHelper.after(item, "onConfigChange", this.onLeafItemConfigChange, item);
    if (item.isContainer) {
      item.eachWidget((w) => this.processAddedLeafItem(w));
    }
  }
  onInternalPaint({ firstPaint }) {
    var _a;
    (_a = super.onInternalPaint) == null ? void 0 : _a.call(this, ...arguments);
    if (firstPaint) {
      this.getConfig("overflow");
    }
  }
  updateDock(dock) {
    var _a;
    const me = this, { layout } = me, { vertical } = layout;
    layout.vertical = canonicalDock(dock)[1];
    if (!me.initialItems) {
      if (vertical !== layout.vertical) {
        me.updateOverflow(me.overflow);
      }
      for (const item of me.childItems) {
        (_a = item.syncRotationToDock) == null ? void 0 : _a.call(item, dock);
      }
    }
  }
  updateOverflow(overflow, oldOverflow) {
    var _a, _b;
    const me = this, { axisProps, contentElement, overflowType } = me, { flexDir } = axisProps, overflowMenu = (_a = me.overflowMenuButton) == null ? void 0 : _a._menu, overflowTools = {};
    if (overflowMenu) {
      if (overflow) {
        overflowMenu == null ? void 0 : overflowMenu.removeAll();
      } else {
        overflowMenu.eachWidget((overflowTwin) => {
          overflowTwin._overflowTwinOrigin.overflowTwin = null;
        });
      }
    }
    if (oldOverflow === "menu") {
      overflowTools.overflowMenuButton = null;
    } else if (oldOverflow === "scroll") {
      overflowTools.overflowScrollStart = overflowTools.overflowScrollEnd = null;
    }
    if (overflowType === "menu") {
      (_b = me.scrollable) == null ? void 0 : _b.destroy();
      contentElement.style.overflow = contentElement.style.overflowX = contentElement.style.overflowY = "";
      overflowTools.overflowMenuButton = {
        cls: {
          [`b-${flexDir}-menu`]: 1
        }
      };
    } else if (overflowType === "scroll") {
      const repeat = typeof overflow === "object" && (overflow == null ? void 0 : overflow.repeat) || defaultRepeat;
      me.scrollable = {
        [axisProps.overflow]: "hidden-scroll",
        element: contentElement,
        internalListeners: {
          scroll: "onContentScroll",
          thisObj: me
        }
      };
      overflowTools.overflowScrollStart = {
        repeat,
        invertRotate: true,
        cls: {
          [`b-${flexDir}-start-scroller`]: 1
        }
      };
      overflowTools.overflowScrollEnd = {
        repeat,
        invertRotate: true,
        cls: {
          [`b-${flexDir}-end-scroller`]: 1
        }
      };
    }
    me.tools = overflowTools;
    if (overflowType) {
      contentElement.classList.add("b-overflow");
      me.monitorResize = true;
      me.syncOverflowVisibility();
    } else {
      contentElement.classList.remove("b-overflow");
      me.monitorResize = false;
    }
  }
  onContentScroll() {
    this.syncScrollerState();
  }
  onStartScrollClick() {
    this.scrollable[this.axisProps.pos] -= 2;
  }
  onEndScrollClick() {
    this.scrollable[this.axisProps.pos] += 2;
  }
  // Only called when monitorResize is true, which is only set when we have an overflow mode
  onInternalResize() {
    super.onInternalResize(...arguments);
    if (this.isPainted) {
      this.syncOverflowVisibility();
    }
  }
  syncOverflowVisibility() {
    const me = this, { overflowType, contentElement, isVisible } = me, { clientSizeProp, edgeProp, sizeProp } = me.axisProps, { overflowMenuButton, overflowScrollStart, overflowScrollEnd } = me.tools, rtl = me.rtl && me.layout.horizontal, menuOverflow = overflowType === "menu", getAvailSpace = () => Math.ceil(
      contentElement[clientSizeProp] + // Since we cannot simply hide these to remove their influence, we need to add their width/height:
      (!overflowScrollStart || overflowScrollStart.hidden ? 0 : overflowScrollStart.rectangle("outer")[sizeProp]) + (!overflowScrollEnd || overflowScrollEnd.hidden ? 0 : overflowScrollEnd.rectangle("outer")[sizeProp])
    ), getContentSize = () => {
      if (visibleItems.length === 0) {
        return 0;
      }
      const rect = visibleItems[visibleItems.length - 1].rectangle(contentElement);
      return Math.floor(rtl ? contentElement[clientSizeProp] - rect.left : rect[edgeProp]);
    };
    let availableSpace, contentSize, eviction, evictionList, it, itemSize, minifiable, minifiables, minified, overflowable, overflowItems, visibleItems;
    if (!isVisible || !overflowType || me.items.length === 0) {
      return;
    }
    me.inSyncOverflowVisibility = true;
    overflowMenuButton == null ? void 0 : overflowMenuButton.hide();
    me.eachWidget((item, control) => {
      minifiable = item.minifiable;
      overflowable = item.overflowable;
      overflowable = minifiable ? overflowable || minifiable : overflowable;
      if (item.floating) {
        control.down = false;
      } else {
        control.down = !overflowable;
        if (item.innerItem) {
          if (item._toolbarOverflow) {
            item.hidden = item._toolbarOverflow = false;
          }
          if (item._toolbarMinified) {
            item.minified = item._toolbarMinified = false;
          }
          if (item.isVisible) {
            minifiable && (minifiables || (minifiables = [])).push(item);
            overflowable && (visibleItems || (visibleItems = [])).push(item);
          }
        }
      }
    });
    if (visibleItems) {
      availableSpace = getAvailSpace();
      contentSize = getContentSize();
    }
    if (visibleItems && contentSize > availableSpace) {
      if (menuOverflow) {
        while (contentSize > availableSpace && (it = minifiables == null ? void 0 : minifiables.pop())) {
          itemSize = contentSize;
          it._toolbarMinified = true;
          it.minified = true;
          contentSize = getContentSize();
          itemSize -= contentSize;
          (minified || (minified = [])).push([it, itemSize]);
        }
        if (contentSize > availableSpace) {
          overflowMenuButton.show();
          availableSpace = getAvailSpace();
          evictionList = _Toolbar.getEvictionList(visibleItems);
          for (eviction of evictionList) {
            if (contentSize > availableSpace) {
              it = eviction[1];
              it._toolbarOverflowWidth = it.width;
              it._toolbarOverflow = true;
              it.hidden = true;
              visibleItems.splice(visibleItems.indexOf(it), 1);
              (overflowItems || (overflowItems = [])).push(eviction);
              contentSize = getContentSize();
            }
          }
          if (overflowItems) {
            overflowItems.sort((a, b) => a[0] - b[0]).forEach((ent, n) => overflowItems[n] = ent[1]);
            while (minified == null ? void 0 : minified.length) {
              [it, itemSize] = minified.pop();
              if (contentSize + itemSize <= availableSpace && !it._toolbarOverflow) {
                contentSize += itemSize;
                it.minified = it._toolbarMinified = false;
              }
            }
            me.syncOverflowMenuButton(overflowItems);
          } else {
            overflowMenuButton.hide();
          }
        }
      } else {
        overflowScrollEnd.show();
        overflowScrollStart.show();
        me.syncScrollerState();
      }
    } else if (!menuOverflow) {
      overflowScrollEnd == null ? void 0 : overflowScrollEnd.hide();
      overflowScrollStart == null ? void 0 : overflowScrollStart.hide();
    }
    me.inSyncOverflowVisibility = false;
  }
  syncOverflowMenuButton(overflowItems) {
    var _a;
    const me = this, { axisProps, overflowMenuButton } = me, menu = {
      cls: "b-toolbar-overflow-menu",
      minWidth: 280,
      items: [],
      align: {
        align: axisProps.horizontal ? "t100-b100" : "r100-l100",
        axisLock: "flexible"
      }
    };
    for (const item of overflowItems) {
      me.overflowItemFilter(item) && item.addToOverflowMenu(
        menu,
        me.horizontal ? twinOverridesHorz : twinOverrides,
        onCreateTwin
      );
    }
    menu.items.forEach((it) => {
      let toolbarItem = it._overflowTwinOrigin, weight = toolbarItem.parent.indexOfChild(toolbarItem);
      if (toolbarItem.parent !== me) {
        weight = me.indexOfChild(toolbarItem.parent) + weight / 1e5;
      }
      it.weight = weight;
    });
    if ((_a = overflowMenuButton._menu) == null ? void 0 : _a.isMenu) {
      const existingMenu = overflowMenuButton.menu, { toAdd, toRemove } = ArrayHelper.delta(menu.items, existingMenu.items, true);
      existingMenu.remove(toRemove);
      existingMenu.add(toAdd);
    } else {
      overflowMenuButton.menu = menu;
    }
  }
  syncScrollerState() {
    const me = this, { axisProps, scrollable } = me, { overflowScrollStart, overflowScrollEnd } = me.tools, scrollPos = scrollable[axisProps.pos], maxScrollPos = scrollable[axisProps.max];
    overflowScrollStart.disabled = !scrollPos;
    overflowScrollEnd.disabled = Math.abs(Math.ceil(scrollPos)) >= Math.abs(maxScrollPos);
  }
  overflowItemFilter(item) {
    const { filter } = this.overflow;
    return Boolean(filter ? filter.call(this, item) : DomHelper.getChildElementCount(item.element));
  }
  // Note that this is called with the thisObj of the tbar item being reconfigured.
  // It propagates the new setting into its toolbar overflow clone.
  onLeafItemConfigChange(origResult, { name, value }) {
    const item = this, toolbar = item.up(isToolbar), overflow = toolbar.hasConfig("overflow"), { overflowTwin } = item;
    if (!overflow || (toolbar == null ? void 0 : toolbar.inSyncOverflowVisibility) || name === "hidden" && value === item._toolbarOverflow) {
      return;
    }
    if (!widthAffecting[name]) {
      if (
        // The way fixed-width widgets manage their _width property is a bit tricky because when monitorResize
        // is in effect. The _width property holds a cached width instead of a configured one.
        item._width != null && !item.monitorResize || // The size of a widget w/flex like '1 1 auto' (ie, the flex-basis is auto) is influenced by its content
        // so config changes could affect its size. Otherwise, the widget is sized to the toolbar's content
        // element and is unaffected by other configs.
        item._flex && !String(item._flex).endsWith("auto")
      ) {
        return;
      }
    }
    if (overflowTwin && !nonSyncedConfigs[name]) {
      overflowTwin[name] = value;
    }
    if ((toolbar == null ? void 0 : toolbar.isPainted) && item.ref !== "overflowMenuButton") {
      if (!((item.isTextField || item.isSlider || item.isCheckbox) && name === "value" && (item.containsFocus || (overflowTwin == null ? void 0 : overflowTwin.containsFocus)))) {
        toolbar.syncOverflowVisibility();
      }
    }
  }
  createWidget(widget) {
    if (widget === "->") {
      widget = {
        type: "widget",
        cls: "b-toolbar-fill"
      };
    } else if (widget === "|") {
      widget = {
        type: "widget",
        cls: "b-toolbar-separator"
      };
    } else if (typeof widget === "string") {
      widget = {
        type: "widget",
        cls: "b-toolbar-text",
        html: widget
      };
    }
    const result = super.createWidget(widget);
    if (this.widgetCls) {
      result.element.classList.add(this.widgetCls);
    }
    return result;
  }
};
__publicField(_Toolbar, "$name", "Toolbar");
__publicField(_Toolbar, "type", "toolbar");
__publicField(_Toolbar, "delayable", {
  syncOverflowVisibility: {
    type: "raf",
    cancelOutstanding: true
  }
  // && 50   // restore the "&& 50" here to help when debugging syncOverflowVisibility
});
__publicField(_Toolbar, "configurable", {
  defaultType: "button",
  dock: "top",
  layout: {
    type: "box"
  },
  /**
   * An object containing typed child widget config objects or {@link @bryntum/core-thin/lib/widget/Widget Widgets}. Can also be
   * specified as an array.
   *
   * If configured as an Object, the property names are used as the child component's
   * {@link Core.widget.Widget#config-ref} name, and the value is the child component's config object.
   *
   * ```javascript
   *  new Toolbar({
   *      appendTo : document.body
   *      items    : [{
   *          type : 'button',
   *          onClick() {
   *
   *          }
   *      }]
   *  })
   * ```
   *
   * Some special items can also be added:
   *
   * - `->` Pushes following items to the other side
   * - `|` Adds a vertical separator
   *
   * ```javascript
   *  new Toolbar({
   *      appendTo : document.body
   *      items    : [
   *      {
   *          type : 'button',
   *          text : 'Click me',
   *          onClick() {
   *
   *          }
   *      },
   *      '|', // separator
   *      {
   *          type : 'textfield',
   *          label : 'Enter name'
   *      },
   *      // Align following items to the end of the toolbar
   *      '->',
   *      {
   *          type : 'button',
   *          text : 'Save',
   *          onClick() {
   *
   *          }
   *      }]
   *  })
   * ```
   *
   * @config {Object<String,ToolbarItems|Boolean|null>|ToolbarItems[]|Core.widget.Widget[]} items
   * @category Content
   */
  /**
   * How this Toolbar should deal with items that overflow its main axis.
   *
   * Values may be:
   * - `'menu'` A button with a menu is shown and the menu contains the overflowing items.
   * - `'scroll'` The items overflow and mey be scrolled into view using the mouse or scroll buttons.
   * - `null` Disable overflow handling
   *
   * When mode is `'menu'`, clones of overflowing toolbar item are created and added to a Menu. Any config
   * changes to the original toolbar item are propagated to the menu's clone, so disabling a toolbar
   * item will make the clone in the menu disabled.
   *
   * The clone of an input field will propagate its `value` changes back to the original. The
   * overflow button, its menu, and the clones should not be accessed or manipulated by application code.
   *
   * Note that cloned items will be allocated a unique, generated ID because all IDs must be unique,
   * so CSS targeting an element ID will not apply to a clone in the overflow menu.
   *
   * Values may also be specified in object form containing the following properties:
   * @config {String|Object|null} overflow
   * @property {'scroll'|'menu'} overflow.type `'scroll'` or `'menu'`
   * @property {ClickRepeaterConfig} overflow.repeat A config object to reconfigure the
   * {@link Core.util.ClickRepeater} which controls auto repeat speed when holding down the scroll buttons
   * when `type` is `'scroll'`
   * @property {Function} overflow.filter A filter function which may return a falsy value to prevent toolbar
   * items from being cloned into the overflow menu.
   * @default 'menu'
   */
  overflow: {
    // Wait until first paint to evaluate so that we can read our CSS style.
    // Set to null on destroy which destroys the overflow Tools and Scroller.
    $config: ["lazy", "nullify"],
    value: {
      type: "menu"
    }
  },
  toolDefaults: {
    overflowMenuButton: {
      type: "button",
      hidden: true,
      icon: "b-icon-menu",
      menuIcon: null,
      ariaLabel: "Show overflowing items",
      defaultCls: {
        "b-overflow-button": 1
      }
    },
    overflowScrollEnd: {
      handler: "up.onEndScrollClick",
      hidden: true,
      defaultCls: {
        "b-icon-angle-right": 1,
        "b-overflow-button": 1,
        "b-icon": 1
      }
    },
    overflowScrollStart: {
      align: "start",
      handler: "up.onStartScrollClick",
      hidden: true,
      defaultCls: {
        "b-icon-angle-left": 1,
        "b-overflow-button": 1,
        "b-icon": 1
      }
    }
  },
  /**
   * Custom CSS class to add to toolbar widgets
   * @config {String}
   * @category CSS
   */
  widgetCls: null,
  /**
   * Determines if the toolbars read-only state should be controlled by its parent.
   *
   * When set to `true`, setting a parent container to read-only will not affect the widget. When set to
   * `false`, it will affect the widget.
   *
   * @category Misc
   * @config {Boolean}
   * @default
   */
  ignoreParentReadOnly: true
});
__publicField(_Toolbar, "prototypeProperties", {
  flexRowCls: "b-hbox",
  flexColCls: "b-vbox"
});
let Toolbar = _Toolbar;
Toolbar.initClass();
Toolbar._$name = "Toolbar";
export {
  Toolbar as default
};
